import { render, staticRenderFns } from "./ItemInformationLayout.vue?vue&type=template&id=88a19f98"
import script from "./ItemInformationLayout.vue?vue&type=script&lang=js"
export * from "./ItemInformationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports